'use client';

import { FC } from 'react';
import { useFormStatus } from 'react-dom';
import { ActionResponse } from 'src/general/helpers/serverActions';
import { getOr } from 'src/utils/getOr';

type Props = {
  formState: ActionResponse<any, any>;
  inputName?: string;
  className?: string;
};

export const FormGenericError: FC<Props> = ({ formState, inputName = 'generic', className }) => {
  const { pending } = useFormStatus();
  const error = getOr(formState, `errors.${inputName}[0]`, null);

  return (
    <div className={className} aria-live="polite" aria-atomic>
      {!!error && !pending && (
        <div className="my-2 rounded-xs bg-red-100 p-4 text-tex-def-tie1" data-testid="formError">
          {error}
        </div>
      )}
    </div>
  );
};
